import React from "react";
import { Link } from "react-router-dom";
import { agencyDashboardRequirementDetail } from "../common/allLinks";
import CommonFiveTextDetails from "../common/CommonFiveTextDetails";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";
import ProjectCoordinatorDetails from "../common/ProjectCoordinatorDetails";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
];

export default function AgencyDashboardContactedCard({ cardData }) {
  return (
    <div className="mt-common-card mt-common-card--agency-dashboard-contact custom-d-flex align-items-center flex-nowrap">
      <div className="flex-shrink-0  mt-common-card--agency-dashboard-contact__colm1">
        <div className="custom-d-flex align-items-center justify-content-between mt-common-card__content-block-1">
          <div>
            <Link to={agencyDashboardRequirementDetail}>
              <h2 className="font-24-NunitoSans-600 mt-common-card__title">
                {cardData.isBookMarked ? (
                  <img
                    src="/img/desktop/icons/white-bookmarked-icon.svg"
                    alt=""
                  />
                ) : (
                  <img
                    src="/img/desktop/icons/white-bookmark-icon.svg"
                    alt=""
                  />
                )}
                3 MERN Stack Developers by Honda
              </h2>
            </Link>
            <CommonFiveTextDetails />
          </div>
          <div className="mobile-d-flex">
            <p className="font-36-NunitoSans-800 text-right">$24</p>
            <p className="font-24-NunitoSans-600 mobile-ml-price">
              {/* per hour per resource */}
              /Hr /Resource
            </p>
          </div>
        </div>
        <hr className="mt-common-card__hr" />
        <div className="mt-common-card__content-block-2">
          <p className="font-18-nunito-light mt-common-card__content-block-2__text-1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <div className="custom-d-flex align-items-start">
            <p className="font-14-NunitoSans-800 mt-common-card__content-block-2__text-2">
              Key Skills
            </p>
            <DisplaySelectedOptionsList
              displayListSelected={optionsSkill}
              isDisplayRemoveIcon={false}
            />
          </div>
        </div>
      </div>
      <div className="flex-grow-1 mt-common-card__content-block-mobile-spacing">
        <div className="custom-d-flex align-items-center">
          <p className="font-16-NunitoSans-600 mt-common-card__content-block-2-text-1">
            <img src="/img/desktop/icons/gray-two-people-icon.svg" alt="" />
            Posted by
          </p>
          <p className="font-18-NunitoSans-600 mt-common-card__content-block-2-text-2">
            <img src="/img/desktop/icons/company-name-icon.svg" alt="" />
            Company name
          </p>
        </div>
        <hr className="mt-common-card__hr-2" />
        <ProjectCoordinatorDetails
          name="Rajesh Tripathi"
          email="RajeshT123@gmail.com"
          phone="+91-23124123123"
        />
      </div>
    </div>
  );
}
